import React from 'react';
import { Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** Nature de l'ajout : intervention sur des PDS existants, ou création de PDS. */
export type ImportKind = 'maintenance' | 'create';

type ImportKindToggleProps = {
  value: ImportKind;
  onChange: (kind: ImportKind) => void;
  /** Clé i18n du libellé — « Type de fichier » via un fichier, « Type » sinon. */
  labelKey: string;
  /** Libellé sur la même ligne que les pastilles plutôt qu'au-dessus. */
  inline?: boolean;
};

export default function ImportKindToggle({
  value,
  onChange,
  labelKey,
  inline = false
}: ImportKindToggleProps) {
  const { t } = useTranslation();

  return (
    <Stack
      direction={inline ? 'row' : 'column'}
      spacing={inline ? 2 : 1}
      alignItems={inline ? 'center' : 'flex-start'}
      flexWrap="wrap"
    >
      <Typography variant="body2">{t(labelKey)}</Typography>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={value}
        // MUI renvoie null quand on reclique sur la pastille active : on garde
        // le type courant, l'un des deux doit toujours être sélectionné.
        onChange={(_, kind: ImportKind | null) => kind && onChange(kind)}
      >
        <ToggleButton value="maintenance">
          {t('interventionCreation.addServicePoints.maintenancePds')}
        </ToggleButton>
        <ToggleButton value="create">
          {t('interventionCreation.addServicePoints.createPds')}
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
}
